import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { menuData } from '../data/menuData';
import { agentDataMap } from '../data/agentDetailData'; // 1. Import the detailed data
import AgentCard from '../components/AgentCard';
import './AgentListPage.css';

// Helper function to create a URL-friendly slug from a title
const createSlug = (text) => {
    if (!text) return '';
    return text.trim().toLowerCase().replace(/ & /g, '-').replace(/[,\/]/g, '').replace(/\s+/g, '-');
};

const AgentListPage = () => {
  const { domain, submenu } = useParams();

  const currentDomain = menuData.find(d => d.path.endsWith(domain));
  const currentSubmenu = currentDomain?.children.find(s => s.path.endsWith(submenu));

  if (!currentSubmenu) {
    return (
        <div className="agent-list-container">
            <h1 className="agent-list-title">Category Not Found</h1>
            <p>Please select a valid category from the sidebar.</p>
            <Link to="/">Go to Homepage</Link>
        </div>
    );
  }

  return (
    <div className="agent-list-container">
      <h1 className="agent-list-title">{currentSubmenu.title}</h1>
      <p className="agent-list-subtitle">Browse and configure the Agentic Agents available in this category.</p>
      <div className="agent-card-grid">
        {currentSubmenu.children.map(agentFromMenu => {
          // 2. For each agent, find its detailed data from agentDataMap
          const slug = createSlug(agentFromMenu.title);
          const detailData = agentDataMap[slug];

          return (
            <AgentCard
              key={agentFromMenu.title}
              title={agentFromMenu.title}
              description={agentFromMenu.description}
              path={agentFromMenu.path}
              live={agentFromMenu.live}
              // 3. Pass the videoPath from the detailed data to the card
              videoPath={detailData?.videoPath}
              isDetailViewEnabled={!!detailData}  
            />
          );
        })}
      </div>
    </div>
  );
};

export default AgentListPage;